/**
 * actions service
 */

import Resource from './resource'

export default new Resource('actions')



// WEBPACK FOOTER //
// ./src/libraries/services/actions.js